var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c("div", { staticClass: "multi-file-select" }, [
      _c("span", {
        staticClass: "input-file-add",
        on: { click: _vm.clickHandler }
      }),
      _c("input", {
        ref: "multiFiles",
        attrs: {
          type: "file",
          id: "multipleFileInput",
          name: _vm.name,
          multiple: _vm.multiple
        },
        on: { change: _vm.handleFileChange }
      }),
      _c(
        "div",
        { staticClass: "file-list" },
        _vm._l(_vm.files, function(file, key) {
          return _c("div", { key: _vm.reloadKey }, [
            _c("div", { staticClass: "single-file", attrs: { id: key } }, [
              _c("div", { class: { "file-name": true } }, [
                _vm._v(_vm._s(_vm.cutDocName(file.name, 16)) + " "),
                _c(
                  "span",
                  { class: { "error-size": file.size / 1024 > _vm.maxSize } },
                  [_vm._v(_vm._s(_vm.displaySize(file.size)))]
                )
              ]),
              _c(
                "span",
                {
                  staticClass: "file-remove",
                  on: {
                    click: function($event) {
                      _vm.removeFile(key)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ])
          ])
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1261f6d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1261f6d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/_any/InputFileMultiple.vue
// module id = 6d+k
// module chunks = 41